export const API_BASE = process.env.EMPLOYMENT_TIME_API;
export const CLIENT_POLICY_API_PATH = 'client-policy';
